<template>
  <div
    :style="avatar_img"
    :class="[
      $style.avatar,
      { [$style.defaultAvatar] : !has_avatar }
    ]"
  >
    <span v-if="!has_avatar">
      {{ default_avatar }}
    </span>

    <template v-if="is_edit">

      <input
        :class="$style.fileInput"
        accept=".jpg, .jpeg, .png"
        type="file"
        id="avatar-input"
        @change="uploaded_new_img"
      >
      <label
        for="avatar-input"
        :class="$style.avatarLabel"
      >
        <v-icon :class="$style.plusIcon">mdi-plus</v-icon>
      </label>
    </template>

  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { file_to_base64 } from '@/utils';

@Component
export default class AvatarComponent extends Vue {
  async mounted() {
    if (this.avatar instanceof File) {
      this.base64_img = await file_to_base64(this.avatar);
    }
  }

  @Prop({ type: String, default: '' })
  original_initials!: string;

  @Prop({ type: Boolean, default: false })
  is_edit!: boolean;

  @Prop({
    type: [
      String,
      File,
    ],
    default: '',
  })
  avatar!: string | File;

  base64_img: string | ArrayBuffer | null = '';

  get default_avatar() {
    if (this.original_initials.length) {
      let [
        name,
        surname,
      ] = this.original_initials.split(' ');

      if (!name) {
        name = ' ';
      }

      if (!surname) {
        surname = ' ';
      }

      return `${surname[0]}${name[0]}`.trim();
    }
    return this.original_initials;
  }

  get has_avatar() {
    return this.avatar || this.base64_img;
  }

  get avatar_img() {
    let img: string | ArrayBuffer | null = '';

    if (this.avatar instanceof File || this.base64_img) {
      img = this.base64_img;
    } else {
      img = this.avatar;
    }

    return { backgroundImage: `url(${img})` };
  }

  async uploaded_new_img(e: Event) {
    const val = (e.target as HTMLInputElement);

    if (val.files?.length) {
      this.base64_img = await file_to_base64(val.files[0]);
      this.$emit('change', val.files[0]);
    }
  }
}
</script>

<style module lang="scss">
.avatar {
  border-radius: 50%;
  width: 74px;
  height: 74px;
  background-color: $primary_lighten4;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.defaultAvatar {
  text-align: center;
  color: $accent_darken4;
  font-size: 48px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.fileInput {
  width: 0;
  height: 0;
  position: absolute;
}

.avatarLabel {
  width: 24px;
  height: 24px;
  position: absolute;
  background-color: $primary_base;
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  bottom: 0;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  .plusIcon {
    color: #fff;
    font-size: 18px;
  }

  &:hover {
    .plusIcon {
      color: $primary_darken3;
    }
  }
}

</style>
